var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Categories',{on:{"selectCategory":_vm.setCategory}}),_c(_vm.feedComponent,{tag:"component",attrs:{"user-id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }